import { ActionType, Action, edocsState } from "../actions/types"

const initialFileState: edocsState = {
  edocs: [],
  isResendVisible: false
}

const edocsReducer = (state: edocsState = initialFileState, action: Action) => {
  switch (action.type) {
    case ActionType.SET_EDOCS:
      return {
        ...state,
        edocs: action.payload
      }
    default:
      return state
  }
}

export default edocsReducer
